import state from '@/store/module_email/state'
import mutations from '@/store/module_email/mutations'
import actions from '@/store/module_email/actions'

export default ({
  state,
  mutations,
  actions,
})